<h2 mat-dialog-title class="dialog-title">
  <mat-icon class="title-icon">error_outline</mat-icon>
  Record Saved By Another User
</h2>

<mat-dialog-content>
  <div class="warning-box">
    <mat-icon class="warning-icon">warning</mat-icon>
    <div class="warning-text">
      <p>
        This record was just updated by another user session.
        Changes saved by the other user session since you loaded this record will be
        overwritten if you update. Also, if you reload now you will lose any changes
        you made to this record since you last loaded it.
      </p>
      <p>
        If you have made changes, press <strong>Cancel</strong>, note your changes,
        reload this page, then apply your changes.
      </p>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button class="reload-btn" [mat-dialog-close]="true">
    <mat-icon>warning</mat-icon>
    Reload (CAUTION)
  </button>
</mat-dialog-actions>
